<template>
  <b-modal ref="modal" centered title="Get state" header-bg-variant="primary" header-text-variant="light" @hide="close">
    <div slot="modal-header-close">
      <a @click="close" class="text-white">
        &times;
      </a>
    </div>
    {{data}}
    <div slot="modal-footer" class="w-100">
      <b-button size="sm" class="float-right" variant="primary" @click="close">Close</b-button>
    </div>
  </b-modal>
</template>

<script>
  export default {
    props: {
      data: {
        type: String,
        default: ''
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      close() {
        this.$refs.modal.hide()
        this.$emit('close')
      }
    },
    watch: {
      show(v) {
        if (v) {
          this.$refs.modal.show()
        }
      }
    }
  }
</script>

<style scoped>
  .modal-title {
    color: #fff;
  }
</style>
